import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Invest from "../../Assets/images/in.png";
import Saving from "../../Assets/images/sav.png";
import Wallet from "../../Assets/images/wallett.png";

import getServices from "../../Services/get-service";
import DashCardComp from "./DashCardComp";
import Constant from "../../Constant";

function Topsec() {
  const [investmentBalance, setInvestmentBalance] = useState(0);
  const [savingsBalance, setSavingsBalance] = useState(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [ledgerBalance, setLedgerBalance] = useState(0);

  const [investmentLoading, setInvestmentLoading] = useState(true);
  const [savingsLoading, setSavingsLoading] = useState(true);
  const [walletLoading, setWalletLoading] = useState(true);

  useEffect(() => {
    fetchInvestmentBalance();
    fetchSavingsBalance();
    fetchWalletBalance();
  }, []);

  const fetchInvestmentBalance = async () => {
    try {
      const response =
        await getServices.getPropertyInvestmentBalance();

      if (response.data?.statusCode === 200) {
        setInvestmentBalance(
          response.data.data?.portfolioValue ?? 0
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.description ||
        "Unable to fetch investment balance"
      );
    } finally {
      setInvestmentLoading(false);
    }
  };

  const fetchSavingsBalance = async () => {
    try {
      const response =
        await getServices.userGetSavingsWalletBalance();

      if (response.data?.statusCode === 200) {
        setSavingsBalance(
          response.data.data?.totalSavingsBalance ?? 0
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.description ||
        "Unable to fetch savings balance"
      );
    } finally {
      setSavingsLoading(false);
    }
  };

  const fetchWalletBalance = async () => {
    try {
      const response =
        await getServices.getWalletBalance();

      if (response.data?.statusCode === 200) {
        const data = response.data.data;

        const wallet = Array.isArray(data)
          ? data[0]
          : data;

        setWalletBalance(wallet?.availableBalance ?? 0);
        setLedgerBalance(wallet?.ledgerBalance ?? 0);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.description ||
        "Unable to fetch wallet balance"
      );
    } finally {
      setWalletLoading(false);
    }
  };

  return (
    <div>
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        <DashCardComp
          img={Invest}
          title="Investment balance"
          sub={Constant.FormatNumber(investmentBalance)}
          loading={investmentLoading}
        />

        <DashCardComp
          img={Saving}
          title="Savings balance"
          sub={Constant.FormatNumber(savingsBalance)}
          loading={savingsLoading}
        />

        <DashCardComp
          img={Wallet}
          title="Wallet balance"
          sub={Constant.FormatNumber(walletBalance)}
          bool={true}
          leadBalance={Constant.FormatNumber(ledgerBalance)}
          loading={walletLoading}
        />
      </div>
    </div>
  );
}

export default Topsec;